import { Form, Offcanvas } from "react-bootstrap";
import { Controller, useForm } from 'react-hook-form';
import { Link, useNavigate, useParams } from 'react-router-dom';
import LoadingButtonWithForm from '../../components/LoadingButtonWithForm';
import { responseError } from '../../helpers/responseHandler';
import { useEditDriverAppMutation, useViewDriverQuery } from '../../redux/services/DriverService';
import { convertToFormDataDeep, sweetAlert } from '../../utils';


const EditDriverApplication = () => {
    const params = useParams()
    const navigate = useNavigate()
    // const { state: { isEdit } } = useLocation()

    let {
        control,
        register,
        handleSubmit,
        setValue,
        watch,
        reset,
        formState: { errors },
    } = useForm()


    const [editRequest, { isLoading: editLoading }] = useEditDriverAppMutation()

    const { data: data2, isLoading, isFetching, refetch } = useViewDriverQuery(params)
    const isEdit = data2?.response?.data


    const onSubmit = async (data) => {

        console.log('data', data);

        const newForm = convertToFormDataDeep({ ...data })
        await editRequest({ id: isEdit?.id, newForm }).unwrap()
            .then((res) => {
                if (res?.status) {
                    sweetAlert(res?.message, 'success')
                    navigate(-1)
                }
            })
            .catch((err) => {
                responseError(err)
            })
    }



    return (
        <>
            <Offcanvas show={true} onHide={() => navigate(-1)} className="canvas-lg bg-light " placement="end">
                <Offcanvas.Header>
                    <Offcanvas.Title>
                        Edit Driver Application
                    </Offcanvas.Title>
                    <button className="btn-close" onClick={() => navigate(-1)}>
                        <i className="ri-close-line" />
                    </button>
                </Offcanvas.Header>
                <Offcanvas.Body className='bg-white'>
                    {!isLoading && (
                        <>
                            <Form onSubmit={handleSubmit(onSubmit)}>
                                <div className="row">
                                    <div className="col-lg-6">
                                        <Form.Group className="mb-3">
                                            <Form.Label>Driver’s License Number:</Form.Label>
                                            <Controller
                                                name="dln"
                                                control={control}
                                                defaultValue={isEdit?.dln || ''}
                                                rules={{
                                                    required: true
                                                }}
                                                render={({ field }) => (
                                                    <Form.Control
                                                        {...field}
                                                        type="text" placeholder="Enter Driver’s License Number"
                                                        isInvalid={errors.dln}
                                                    />
                                                )}
                                            />
                                        </Form.Group>
                                    </div>
                                    <div className="col-lg-6">
                                        <Form.Group className="mb-3">
                                            <Form.Label>State of Issuance:</Form.Label>
                                            <Controller
                                                name="state_of_issuance"
                                                control={control}
                                                defaultValue={isEdit?.state_of_issuance || ''}
                                                rules={{
                                                    required: true
                                                }}
                                                render={({ field }) => (
                                                    <Form.Control
                                                        {...field}
                                                        type="text" placeholder="Enter State of Issuance"
                                                        isInvalid={errors.state_of_issuance}
                                                    />
                                                )}
                                            />
                                        </Form.Group>
                                    </div>
                                    <div className="col-lg-6">
                                        <Form.Group className="mb-3">
                                            <Form.Label>License Class:</Form.Label>
                                            <Controller
                                                name="license_class"
                                                control={control}
                                                defaultValue={isEdit?.license_class || ''}
                                                rules={{
                                                    required: true,
                                                    maxLength: {
                                                        value: 10,
                                                        message: 'License class cannot be longer than 10 characters'
                                                    }
                                                }}
                                                render={({ field }) => (
                                                    <Form.Control
                                                        {...field}
                                                        type="text" placeholder="Enter License Class"
                                                        isInvalid={errors.license_class}
                                                    />
                                                )}
                                            />
                                            {errors.license_class && (
                                                <Form.Control.Feedback type="invalid">
                                                    {errors.license_class.message}
                                                </Form.Control.Feedback>
                                            )}
                                        </Form.Group>
                                    </div>
                                    <div className="col-lg-6">
                                        <Form.Group className="mb-3">
                                            <Form.Label>Status:</Form.Label>
                                            <Controller
                                                name="license_status"
                                                control={control}
                                                defaultValue={isEdit?.license_status || ''}
                                                rules={{
                                                    required: true
                                                }}
                                                render={({ field }) => (
                                                    <Form.Control
                                                        {...field}
                                                        type="text" placeholder="Enter Status"
                                                        isInvalid={errors.license_status}
                                                    />
                                                )}
                                            />
                                        </Form.Group>
                                    </div>
                                    <div className="col-lg-6">
                                        <Form.Group className="mb-3">
                                            <Form.Label>Restrictions:</Form.Label>
                                            <Controller
                                                name="restrictions"
                                                control={control}
                                                defaultValue={isEdit?.restrictions || ''}
                                                rules={{
                                                    required: true
                                                }}
                                                render={({ field }) => (
                                                    <Form.Control
                                                        {...field}
                                                        type="text" placeholder="Enter Restrictions"
                                                        isInvalid={errors.restrictions}
                                                    />
                                                )}
                                            />
                                        </Form.Group>
                                    </div>
                                    <div className="col-lg-6">
                                        <Form.Group className="mb-3">
                                            <Form.Label>Endorsements:</Form.Label>
                                            <Controller
                                                name="endorsements"
                                                control={control}
                                                defaultValue={isEdit?.endorsements || ''}
                                                rules={{
                                                    required: true
                                                }}
                                                render={({ field }) => (
                                                    <Form.Control
                                                        {...field}
                                                        type="text" placeholder="Enter Endorsements"
                                                        isInvalid={errors.endorsements}
                                                    />
                                                )}
                                            />
                                        </Form.Group>
                                    </div>
                                    <div className="col-lg-6">
                                        <Form.Group className="mb-3">
                                            <Form.Label>Issue Date:</Form.Label>
                                            <Controller
                                                name="issue_date"
                                                control={control}
                                                defaultValue={isEdit?.issue_date || ''}
                                                rules={{
                                                    required: true
                                                }}
                                                render={({ field }) => (
                                                    <Form.Control
                                                        {...field}
                                                        type="date" placeholder="Enter Issue Date"
                                                        isInvalid={errors.issue_date}
                                                    />
                                                )}
                                            />
                                        </Form.Group>
                                    </div>
                                    <div className="col-lg-6">
                                        <Form.Group className="mb-3">
                                            <Form.Label>Expiration Date:</Form.Label>
                                            <Controller
                                                name="expiration_date"
                                                control={control}
                                                defaultValue={isEdit?.expiration_date || ''}
                                                rules={{
                                                    required: true
                                                }}
                                                render={({ field }) => (
                                                    <Form.Control
                                                        {...field}
                                                        type="date" placeholder="Enter Expiration Date"
                                                        isInvalid={errors.expiration_date}
                                                    />
                                                )}
                                            />
                                        </Form.Group>
                                    </div>
                                    <div className="col-lg-6">
                                        <Form.Group className="mb-3">
                                            <Form.Label>Upload Front Copy of Driver's License:</Form.Label>
                                            <Controller
                                                name="driver_license_copy"
                                                control={control}
                                                defaultValue={''}
                                                rules={{
                                                    required: isEdit?.driver_license_copy ? false : true,
                                                    validate: {
                                                        fileSize: (file) => {
                                                            if (!file) return true; // allow empty if not required
                                                            return file.size <= 5 * 1024 * 1024 || 'File size must be less than 5MB';
                                                        },
                                                        fileType: (file) => {
                                                            if (!file) return true; // skip if not required
                                                            const allowedTypes = ['image/jpeg', 'image/png', 'application/pdf'];
                                                            return allowedTypes.includes(file.type) || 'Only JPEG, PNG, or PDF files are allowed';
                                                        },
                                                    },
                                                }}
                                                render={({ field }) => (
                                                    <>
                                                        <Form.Control
                                                            type="file"
                                                            onChange={(e) => field.onChange(e.target.files[0])}
                                                            isInvalid={errors.driver_license_copy}
                                                        />
                                                        {errors.driver_license_copy && (
                                                            <Form.Control.Feedback type="invalid">
                                                                {errors.driver_license_copy.message}
                                                            </Form.Control.Feedback>
                                                        )}
                                                    </>
                                                )}
                                            />
                                            {isEdit?.driver_license_copy_url && (
                                                <Link to={isEdit?.driver_license_copy_url || ''} target='_blank'>
                                                    <span className='d-inline-block text-primary my-1'>View Uploaded File</span>
                                                </Link>
                                            )}
                                        </Form.Group>
                                    </div>
                                    <div className="col-lg-6">
                                        <Form.Group className="mb-3">
                                            <Form.Label>Upload Back Copy of Driver's License:</Form.Label>
                                            <Controller
                                                name="driver_license_back"
                                                control={control}
                                                defaultValue={''}
                                                rules={{
                                                    required: isEdit?.driver_license_back ? false : true,
                                                    validate: {
                                                        fileSize: (file) => {
                                                            if (!file) return true; // allow empty if not required
                                                            return file.size <= 5 * 1024 * 1024 || 'File size must be less than 5MB';
                                                        },
                                                        fileType: (file) => {
                                                            if (!file) return true; // skip if not required
                                                            const allowedTypes = ['image/jpeg', 'image/png', 'application/pdf'];
                                                            return allowedTypes.includes(file.type) || 'Only JPEG, PNG, or PDF files are allowed';
                                                        },
                                                    },
                                                }}
                                                render={({ field }) => (
                                                    <>
                                                        <Form.Control
                                                            type="file"
                                                            onChange={(e) => field.onChange(e.target.files[0])}
                                                            isInvalid={errors.driver_license_back}
                                                        />
                                                        {errors.driver_license_back && (
                                                            <Form.Control.Feedback type="invalid">
                                                                {errors.driver_license_back.message}
                                                            </Form.Control.Feedback>
                                                        )}
                                                    </>

                                                )}
                                            />
                                            {isEdit?.driver_license_back_url && (
                                                <Link to={isEdit?.driver_license_back_url || ''} target='_blank'>
                                                    <span className='d-inline-block text-primary my-1'>View Uploaded File</span>
                                                </Link>
                                            )}
                                        </Form.Group>
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col-lg-6">
                                        <Form.Group className="mb-3">
                                            <Form.Label>Date of Last Drug Test:</Form.Label>
                                            <Controller
                                                name="last_drug_test"
                                                control={control}
                                                defaultValue={isEdit?.last_drug_test || ''}
                                                rules={{
                                                    required: true
                                                }}
                                                render={({ field }) => (
                                                    <Form.Control
                                                        {...field}
                                                        type="date" placeholder="Enter Date of Last Drug Test"
                                                        isInvalid={errors.last_drug_test}
                                                    />
                                                )}
                                            />
                                        </Form.Group>
                                    </div>
                                    <div className="col-lg-6">
                                        <Form.Group className="mb-3">
                                            <Form.Label>Drug Test Result:</Form.Label>
                                            <Controller
                                                name="drug_test_result"
                                                control={control}
                                                defaultValue={isEdit?.drug_test_result || ''}
                                                rules={{
                                                    required: true
                                                }}
                                                render={({ field }) => (
                                                    <Form.Control
                                                        {...field}
                                                        type="text" placeholder="Enter Drug Test Result"
                                                        isInvalid={errors.drug_test_result}
                                                    />
                                                )}
                                            />
                                        </Form.Group>
                                    </div>
                                    <div className="col-lg-6">
                                        <Form.Group className="mb-3">
                                            <Form.Label>Drug Test Provider Name:</Form.Label>
                                            <Controller
                                                name="drug_test_provider_name"
                                                control={control}
                                                defaultValue={isEdit?.drug_test_provider_name || ''}
                                                rules={{
                                                    required: true
                                                }}
                                                render={({ field }) => (
                                                    <Form.Control
                                                        {...field}
                                                        type="text" placeholder="Enter Drug Test Provider Name"
                                                        isInvalid={errors.drug_test_provider_name}
                                                    />
                                                )}
                                            />
                                        </Form.Group>
                                    </div>
                                    <div className="col-lg-6">
                                        <Form.Group className="mb-3">
                                            <Form.Label>Facility Contact Information:</Form.Label>
                                            <Controller
                                                name="facility_contact"
                                                control={control}
                                                defaultValue={isEdit?.facility_contact || ''}
                                                rules={{
                                                    required: true
                                                }}
                                                render={({ field }) => (
                                                    <Form.Control
                                                        {...field}
                                                        type="text" placeholder="Enter Facility Contact Information"
                                                        isInvalid={errors.facility_contact}
                                                    />
                                                )}
                                            />
                                        </Form.Group>
                                    </div>
                                    <div className="col-lg-6">
                                        <Form.Group className="mb-3">
                                            <Form.Label>Link to Government Clearinghouse:</Form.Label>
                                            <Controller
                                                name='link_to_government_clearinghouse'
                                                control={control}
                                                defaultValue={isEdit?.link_to_government_clearinghouse || ''}
                                                rules={{
                                                    required: true
                                                }}
                                                render={({ field }) => (
                                                    <Form.Control
                                                        {...field}
                                                        type="url" placeholder="Enter Link to Government Clearinghouse"
                                                        isInvalid={errors.link_to_government_clearinghouse}
                                                    />
                                                )}
                                            />
                                        </Form.Group>
                                    </div>
                                    <div className="col-lg-6">
                                        <Form.Group className="mb-3">
                                            <Form.Label htmlFor='result_submission'>Consent for Drug Test Result Submission:</Form.Label>
                                            <Controller
                                                name='drug_test_result_submission'
                                                control={control}
                                                defaultValue={isEdit?.drug_test_result_submission || false}
                                                rules={{
                                                    required: true
                                                }}
                                                render={({ field }) => (
                                                    <Form.Check
                                                        {...field}
                                                        defaultChecked={field.value}
                                                        id="result_submission"
                                                        label="I give consent for drug test result submission"
                                                        isInvalid={errors.drug_test_result_submission}
                                                    />
                                                )}
                                            />
                                        </Form.Group>

                                    </div>
                                </div>


                                <div className="row">
                                    <div className="col-lg-6">
                                        <Form.Group className="mb-3">
                                            <Form.Label>Employer Name:</Form.Label>
                                            <Controller
                                                name={`employment_history.0.employer_name`}
                                                control={control}
                                                defaultValue={isEdit?.employment_history?.[0]?.name || ''}
                                                rules={{ required: true }}
                                                render={({ field }) => (
                                                    <Form.Control
                                                        type="text"
                                                        placeholder="Enter Employer Name"
                                                        {...field}
                                                        isInvalid={errors.employment_history?.[0]?.employer_name}
                                                    />
                                                )}
                                            />
                                        </Form.Group>
                                    </div>
                                    <div className="col-lg-6">
                                        <Form.Group className="mb-3">
                                            <Form.Label>Job Title:</Form.Label>
                                            <Controller
                                                name={`employment_history.0.job_title`}
                                                control={control}
                                                defaultValue={isEdit?.employment_history?.[0]?.job_title || ''}
                                                rules={{ required: true }}
                                                render={({ field }) => (
                                                    <Form.Control
                                                        type="text"
                                                        placeholder="Enter Job Title"
                                                        {...field}
                                                        isInvalid={errors.employment_history?.[0]?.job_title}
                                                    />
                                                )}
                                            />
                                        </Form.Group>
                                    </div>
                                    <div className="col-lg-6">
                                        <Form.Group className="mb-3">
                                            <Form.Label>Start Date:</Form.Label>
                                            <Controller
                                                name={`employment_history.0.start_date`}
                                                control={control}
                                                defaultValue={isEdit?.employment_history?.[0]?.start_date || ''}
                                                rules={{ required: true }}
                                                render={({ field }) => (
                                                    <Form.Control
                                                        type="date"
                                                        placeholder="Enter Start Date"
                                                        {...field}
                                                        isInvalid={errors.employment_history?.[0]?.start_date}
                                                    />
                                                )}
                                            />
                                        </Form.Group>
                                    </div>
                                    <div className="col-lg-6">
                                        <Form.Group className="mb-3">
                                            <Form.Label>End Date:</Form.Label>
                                            <Controller
                                                name={`employment_history.0.end_date`}
                                                control={control}
                                                defaultValue={isEdit?.employment_history?.[0]?.end_date || ''}
                                                rules={{ required: true }}
                                                render={({ field }) => (
                                                    <Form.Control
                                                        type="date"
                                                        placeholder="Enter End Date"
                                                        {...field}
                                                        isInvalid={errors.employment_history?.[0]?.end_date}
                                                    />
                                                )}
                                            />
                                        </Form.Group>
                                    </div>
                                    <div className="col-lg-6">
                                        <Form.Group className="mb-3">
                                            <Form.Label>Reason for Leaving:</Form.Label>
                                            <Controller
                                                name={`employment_history.0.reason_for_living`}
                                                control={control}
                                                defaultValue={isEdit?.employment_history?.[0]?.reason_for_living || ''}
                                                rules={{ required: true }}
                                                render={({ field }) => (
                                                    <Form.Control
                                                        type="text"
                                                        placeholder="Enter Reason for Leaving"
                                                        {...field}
                                                        isInvalid={errors.employment_history?.[0]?.reason_for_living}
                                                    />
                                                )}
                                            />
                                        </Form.Group>
                                    </div>
                                    <div className="col-lg-6">
                                        <Form.Group className="mb-3">
                                            <Form.Label>Pre-Employment Drug Test Date:</Form.Label>
                                            <Controller
                                                name={`employment_history.0.pre_employment_drug_test_date`}
                                                control={control}
                                                defaultValue={isEdit?.employment_history?.[0]?.drug_test_date || ''}
                                                rules={{ required: true }}
                                                render={({ field }) => (
                                                    <Form.Control
                                                        type="date"
                                                        placeholder="Enter Pre-Employment Drug Test Date"
                                                        {...field}
                                                        isInvalid={errors.employment_history?.[0]?.pre_employment_drug_test_date}
                                                    />
                                                )}
                                            />
                                        </Form.Group>
                                    </div>
                                    <div className="col-lg-12">
                                        <Form.Group className="mb-3">
                                            <Form.Label>References:</Form.Label>
                                            <Controller
                                                name={`employment_history.0.References`}
                                                control={control}
                                                defaultValue={isEdit?.employment_history?.[0]?.references || ''}
                                                rules={{ required: true }}
                                                render={({ field }) => (
                                                    <Form.Control
                                                        as="textarea"
                                                        rows={3}
                                                        placeholder="Enter References"
                                                        {...field}
                                                        isInvalid={errors.employment_history?.[0]?.References}
                                                    />
                                                )}
                                            />
                                        </Form.Group>
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col-lg-6">
                                        <Form.Group className="mb-3">
                                            <Form.Label>Social Security Number:</Form.Label>
                                            <Controller
                                                name='ssn'
                                                control={control}
                                                defaultValue={isEdit?.ssn || ''}
                                                rules={{ required: true }}
                                                render={({ field }) => (
                                                    <Form.Control
                                                        type="text"
                                                        placeholder="Enter Social Security Number"
                                                        {...field}
                                                        isInvalid={errors.ssn}
                                                    />
                                                )}
                                            />
                                        </Form.Group>
                                    </div>
                                    <div className="col-lg-6">
                                        <Form.Group className="mb-3">
                                            <Form.Label htmlFor="cssv">Consent for Social Security Verification:</Form.Label>
                                            <Controller
                                                name='cssv'
                                                control={control}
                                                defaultValue={isEdit?.cssv == 'true' ? true : false}
                                                rules={{ required: true }}
                                                render={({ field }) => (
                                                    <Form.Check
                                                        type="checkbox"
                                                        defaultChecked={field.value}
                                                        id="cssv"
                                                        label="I consent to the Social Security Verification"
                                                        {...field}
                                                        isInvalid={errors.cssv}
                                                    />
                                                )}
                                            />
                                        </Form.Group>
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col-lg-6">
                                        <Form.Group className="mb-3">
                                            <Form.Label htmlFor='authorization_mvr_check'>Authorization for MVR Check:</Form.Label>
                                            <Controller
                                                name='authorization_mvr_check'
                                                control={control}
                                                defaultValue={isEdit?.authorization_mvr_check == 'true' ? true : false}
                                                rules={{ required: true }}
                                                render={({ field }) => (
                                                    <Form.Check
                                                        type="checkbox"
                                                        defaultChecked={field.value}
                                                        id="authorization_mvr_check"
                                                        label="I authorize the release of my Motor Vehicle Record (MVR) to the Company"
                                                        {...field}
                                                        isInvalid={errors.authorization_mvr_check}
                                                    />
                                                )}
                                            />
                                        </Form.Group>
                                    </div>
                                    <div className="col-lg-6">
                                        <Form.Group className="mb-3">
                                            <Form.Label>Driver’s License Number:</Form.Label>
                                            <Controller
                                                name='mvr_dln'
                                                control={control}
                                                defaultValue={isEdit?.mvr_dln || ''}
                                                rules={{ required: true }}
                                                render={({ field }) => (
                                                    <Form.Control
                                                        type="text"
                                                        placeholder="Enter Driver’s License Number"
                                                        {...field}
                                                        isInvalid={errors.mvr_dln}
                                                    />
                                                )}
                                            />
                                        </Form.Group>
                                    </div>
                                    <div className="col-lg-6">
                                        <Form.Group className="mb-3">
                                            <Form.Label>State of Issue:</Form.Label>
                                            <Controller
                                                name='mvr_state_issue'
                                                control={control}
                                                defaultValue={isEdit?.mvr_state_issue || ''}
                                                rules={{ required: true }}
                                                render={({ field }) => (
                                                    <Form.Control
                                                        type="text"
                                                        placeholder="Enter State of Issue"
                                                        {...field}
                                                        isInvalid={errors.mvr_state_issue}
                                                    />
                                                )}
                                            />
                                        </Form.Group>
                                    </div>
                                    <div className="col-lg-6">
                                        <Form.Group className="mb-3">
                                            <Form.Label>MVR Expiration Date:</Form.Label>
                                            <Controller
                                                name='mvr_expiration_date'
                                                control={control}
                                                defaultValue={isEdit?.mvr_expiration_date || ''}
                                                rules={{
                                                    required: true,
                                                    validate: (value) => {
                                                        if (!value) return 'MVR Expiration Date is required';
                                                        const selectedDate = new Date(value);
                                                        const today = new Date();
                                                        today.setHours(0, 0, 0, 0); // ignore time part
                                                        return selectedDate > today || 'Date must be greater than today';
                                                    },
                                                }}
                                                render={({ field }) => (
                                                    <Form.Control
                                                        type="date"
                                                        placeholder="Enter MVR Expiration Date"
                                                        {...field}
                                                        isInvalid={errors.mvr_expiration_date}
                                                    />
                                                )}
                                            />
                                            <Form.Control.Feedback type="invalid">
                                                {errors.mvr_expiration_date?.message}
                                            </Form.Control.Feedback>

                                        </Form.Group>
                                    </div>
                                    <div className="col-lg-6">
                                        <Form.Group className="mb-3">
                                            <Form.Label>Upload MVR Report:</Form.Label>
                                            <Controller
                                                name='mvr_report'
                                                control={control}
                                                defaultValue={''}
                                                rules={{
                                                    required: isEdit?.mvr_report ? false : true,
                                                    validate: {
                                                        fileSize: (file) => {
                                                            if (!file) return true; // allow empty if not required
                                                            return file.size <= 5 * 1024 * 1024 || 'File size must be less than 5MB';
                                                        },
                                                        fileType: (file) => {
                                                            if (!file) return true; // skip if not required
                                                            const allowedTypes = ['image/jpeg', 'image/png', 'application/pdf'];
                                                            return allowedTypes.includes(file.type) || 'Only JPEG, PNG, or PDF files are allowed';
                                                        },
                                                    },
                                                }}
                                                render={({ field }) => (
                                                    <>
                                                        <Form.Control
                                                            type="file"
                                                            onChange={(e) => field.onChange(e.target.files[0])}
                                                            isInvalid={errors.mvr_report}
                                                        />
                                                        {errors.mvr_report && (
                                                            <Form.Control.Feedback type="invalid">
                                                                {errors.mvr_report.message}
                                                            </Form.Control.Feedback>
                                                        )}
                                                    </>
                                                )}
                                            />
                                            {isEdit?.mvr_report_url && (
                                                <Link to={isEdit?.mvr_report_url || ''} target='_blank'>
                                                    <span className='d-inline-block text-primary my-1'>View Uploaded File</span>
                                                </Link>
                                            )}
                                        </Form.Group>
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col-lg-6">
                                        <Form.Group className="mb-3">
                                            <Form.Label htmlFor='ConsentBackground'>Consent for Background Check:</Form.Label>
                                            <Controller
                                                name='consent_bc'
                                                control={control}
                                                defaultValue={Boolean(isEdit?.consent_bc) ? 1 : 0}
                                                rules={{ required: true }}
                                                render={({ field }) => (
                                                    <Form.Check
                                                        type="checkbox"
                                                        defaultChecked={field.value}
                                                        id="ConsentBackground"
                                                        label="I give consent for background check"
                                                        onChange={(e) => field.onChange(e.target.checked ? 1 : 0)}
                                                        isInvalid={errors.consent_bc}
                                                    />
                                                )}
                                            />
                                        </Form.Group>
                                    </div>
                                    <div className="col-lg-6">
                                        <Form.Group className="mb-3">
                                            <Form.Label htmlFor='ConsentDrug'>Consent for Drug Testing:</Form.Label>
                                            <Controller
                                                name='consent_drug_testing'
                                                control={control}
                                                defaultValue={Boolean(Number(isEdit?.consent_drug_testing)) ? 1 : 0}
                                                rules={{ required: true }}
                                                render={({ field }) => (
                                                    <Form.Check
                                                        type="checkbox"
                                                        defaultChecked={field.value}
                                                        id="ConsentDrug"
                                                        label="I give consent for drug testing"
                                                        onChange={(e) => field.onChange(e.target.checked ? 1 : 0)}
                                                        isInvalid={errors.consent_drug_testing}
                                                    />
                                                )}
                                            />
                                        </Form.Group>
                                    </div>
                                    <div className="col-lg-6">
                                        <Form.Group className="mb-3">
                                            <Form.Label htmlFor='ConsentSocial'>Consent for Social Security Verification:</Form.Label>
                                            <Controller
                                                name='consent_ssv'
                                                control={control}
                                                defaultValue={Boolean(isEdit?.consent_ssv) ? 1 : 0}
                                                rules={{ required: true }}
                                                render={({ field }) => (
                                                    <Form.Check
                                                        type="checkbox"
                                                        defaultChecked={field.value}
                                                        id="ConsentSocial"
                                                        label="I give consent for social security verification"
                                                        onChange={(e) => field.onChange(e.target.checked ? 1 : 0)}
                                                        isInvalid={errors.consent_ssv}
                                                    />
                                                )}
                                            />
                                        </Form.Group>
                                    </div>
                                    <div className="col-lg-6">
                                        <Form.Group className="mb-3">
                                            <Form.Label htmlFor='ConsentVR'>Consent to MVR Check:</Form.Label>
                                            <Controller
                                                name='consent_mvr_check'
                                                control={control}
                                                defaultValue={Boolean(isEdit?.consent_mvr_check) ? 1 : 0}
                                                rules={{ required: true }}
                                                render={({ field }) => (
                                                    <Form.Check
                                                        type="checkbox"
                                                        defaultChecked={field.value}
                                                        id="ConsentVR"
                                                        label="I give consent to MVR check"
                                                        onChange={(e) => field.onChange(e.target.checked ? 1 : 0)}
                                                        isInvalid={errors.consent_mvr_check}
                                                    />
                                                )}
                                            />
                                        </Form.Group>
                                    </div>

                                </div>

                                <div className="row">
                                    <div className="col-lg-6">
                                        <Form.Group className="mb-3">
                                            <Form.Label>Upload Copy of Medical Examiner's Certificate:</Form.Label>
                                            <Controller
                                                name='medical_examiner_certificate'
                                                control={control}
                                                defaultValue={''}
                                                rules={{
                                                    required: isEdit?.medical_examiner_certificate ? false : true,
                                                    validate: {
                                                        fileSize: (file) => {
                                                            if (!file) return true; // allow empty if not required
                                                            return file.size <= 5 * 1024 * 1024 || 'File size must be less than 5MB';
                                                        },
                                                        fileType: (file) => {
                                                            if (!file) return true; // skip if not required
                                                            const allowedTypes = ['image/jpeg', 'image/png', 'application/pdf'];
                                                            return allowedTypes.includes(file.type) || 'Only JPEG, PNG, or PDF files are allowed';
                                                        },
                                                    },
                                                }}
                                                render={({ field }) => (
                                                    <>
                                                        <Form.Control
                                                            type="file"
                                                            onChange={(e) => field.onChange(e.target.files[0])}
                                                            isInvalid={errors.medical_examiner_certificate}
                                                        />
                                                        {errors.medical_examiner_certificate && (
                                                            <Form.Control.Feedback type="invalid">
                                                                {errors.medical_examiner_certificate.message}
                                                            </Form.Control.Feedback>
                                                        )}
                                                    </>

                                                )}
                                            />
                                            {isEdit?.medical_examiner_certificate_url ? (
                                                <p>
                                                    <a href={isEdit?.medical_examiner_certificate_url} target='_blank' className='text-primary my-1'>
                                                        View Upload File
                                                    </a>
                                                </p>
                                            ) : '-'}
                                        </Form.Group>
                                    </div>
                                    <div className="col-lg-6">
                                        <Form.Group className="mb-3">
                                            <Form.Label>Upload Copy of MVR Report:</Form.Label>
                                            <Controller
                                                name='mvr_report'
                                                control={control}
                                                defaultValue={''}
                                                rules={{
                                                    required: isEdit?.mvr_report ? false : true,
                                                    validate: {
                                                        fileSize: (file) => {
                                                            if (!file) return true; // allow empty if not required
                                                            return file.size <= 5 * 1024 * 1024 || 'File size must be less than 5MB';
                                                        },
                                                        fileType: (file) => {
                                                            if (!file) return true; // skip if not required
                                                            const allowedTypes = ['image/jpeg', 'image/png', 'application/pdf'];
                                                            return allowedTypes.includes(file.type) || 'Only JPEG, PNG, or PDF files are allowed';
                                                        },
                                                    },
                                                }}
                                                render={({ field }) => (
                                                    <>
                                                        <Form.Control
                                                            type="file"
                                                            onChange={(e) => field.onChange(e.target.files[0])}
                                                            isInvalid={errors.mvr_report}
                                                        />
                                                        {errors.mvr_report && (
                                                            <Form.Control.Feedback type="invalid">
                                                                {errors.mvr_report.message}
                                                            </Form.Control.Feedback>
                                                        )}
                                                    </>
                                                )}
                                            />
                                            {isEdit?.mvr_report_url ? (
                                                <p>
                                                    <a href={isEdit?.mvr_report_url} target='_blank' className='text-primary my-1'>
                                                        View Upload File
                                                    </a>
                                                </p>
                                            ) : '-'}
                                        </Form.Group>
                                    </div>
                                    <div className="col-lg-6">
                                        <Form.Group className="mb-3">
                                            <Form.Label>Upload Copy of Social Security Card:</Form.Label>
                                            <Controller
                                                name='ssc_file'
                                                control={control}
                                                defaultValue={''}
                                                rules={{
                                                    required: isEdit?.ssc_file ? false : true,
                                                    validate: {
                                                        fileSize: (file) => {
                                                            if (!file) return true; // allow empty if not required
                                                            return file.size <= 5 * 1024 * 1024 || 'File size must be less than 5MB';
                                                        },
                                                        fileType: (file) => {
                                                            if (!file) return true; // skip if not required
                                                            const allowedTypes = ['image/jpeg', 'image/png', 'application/pdf'];
                                                            return allowedTypes.includes(file.type) || 'Only JPEG, PNG, or PDF files are allowed';
                                                        },
                                                    },
                                                }}
                                                render={({ field }) => (
                                                    <>
                                                        <Form.Control
                                                            type="file"
                                                            onChange={(e) => field.onChange(e.target.files[0])}
                                                            isInvalid={errors.ssc_file}
                                                        />
                                                        {errors.ssc_file && (
                                                            <Form.Control.Feedback type="invalid">
                                                                {errors.ssc_file.message}
                                                            </Form.Control.Feedback>
                                                        )}
                                                    </>

                                                )}
                                            />
                                            {isEdit?.ssc_file_url ? (
                                                <p>
                                                    <a href={isEdit?.ssc_file_url} target='_blank' className='text-primary my-1'>
                                                        View Upload File
                                                    </a>
                                                </p>
                                            ) : '-'}
                                        </Form.Group>
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col-lg-6">
                                        <Form.Group className="mb-3">
                                            <Form.Label>Name:</Form.Label>
                                            <Controller
                                                name={`emergency_contact.0.name`}
                                                control={control}
                                                defaultValue={isEdit?.emergency_contact?.[0]?.name || ''}
                                                rules={{
                                                    required: false,
                                                }}
                                                render={({ field }) => (
                                                    <Form.Control
                                                        {...field}
                                                        type="text"
                                                        placeholder="Enter Name"
                                                        isInvalid={errors?.emergency_contact?.[0]?.name}
                                                    />
                                                )}
                                            />


                                        </Form.Group>
                                    </div>
                                    <div className="col-lg-6">
                                        <Form.Group className="mb-3">
                                            <Form.Label>Relationship:</Form.Label>
                                            <Controller
                                                name={`emergency_contact.0.relationship`}
                                                control={control}
                                                defaultValue={isEdit?.emergency_contact?.[0]?.relationship || ''}
                                                rules={{ required: false }}
                                                render={({ field }) => (
                                                    <Form.Control
                                                        {...field}
                                                        type="text"
                                                        placeholder="Enter Relationship"
                                                        isInvalid={errors?.emergency_contact?.[0]?.relationship}
                                                    />
                                                )}
                                            />
                                        </Form.Group>
                                    </div>
                                    <div className="col-lg-6">
                                        <Form.Group className="mb-3">
                                            <Form.Label>Phone Number:</Form.Label>
                                            <Controller
                                                name={`emergency_contact.0.phone`}
                                                control={control}
                                                defaultValue={isEdit?.emergency_contact?.[0]?.phone || ''}
                                                rules={{
                                                    required: false,
                                                    maxLength: {
                                                        value: 15,
                                                        message: 'Name must not be greater than 15 characters'
                                                    }
                                                }}
                                                render={({ field }) => (
                                                    <Form.Control
                                                        {...field}
                                                        type="text"
                                                        placeholder="Enter Phone Number"
                                                        isInvalid={errors?.emergency_contact?.[0]?.phone}
                                                    />
                                                )}
                                            />
                                            <Form.Control.Feedback type="invalid">
                                                {errors?.emergency_contact?.[0]?.name?.message}
                                            </Form.Control.Feedback>
                                        </Form.Group>
                                    </div>
                                    <div className="col-lg-6">
                                        <Form.Group className="mb-3">
                                            <Form.Label>Email:</Form.Label>
                                            <Controller
                                                name={`emergency_contact.0.email`}
                                                control={control}
                                                defaultValue={isEdit?.emergency_contact?.[0]?.email || ''}
                                                rules={{ required: false }}
                                                render={({ field }) => (
                                                    <Form.Control
                                                        {...field}
                                                        type="email"
                                                        placeholder="Enter Email"
                                                        isInvalid={errors?.emergency_contact?.[0]?.email}
                                                    />
                                                )}
                                            />
                                        </Form.Group>
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col-lg-6">
                                        <Form.Group className="mb-3">
                                            <Form.Label>Medical Examiner's Certificate Number:</Form.Label>
                                            <Controller
                                                name='medical_examiner_certificate_number'
                                                control={control}
                                                defaultValue={isEdit?.medical_examiner_certificate_number || ''}
                                                rules={{ required: true }}
                                                render={({ field }) => (
                                                    <Form.Control
                                                        type="text"
                                                        placeholder="Enter Medical Examiner's Certificate Number"
                                                        {...field}
                                                        isInvalid={errors.medical_examiner_certificate_number}
                                                    />
                                                )}
                                            />
                                        </Form.Group>
                                    </div>
                                    <div className="col-lg-6">
                                        <Form.Group className="mb-3">
                                            <Form.Label>Medical Examination Date:</Form.Label>
                                            <Controller
                                                name='medical_examiner_date'
                                                control={control}
                                                defaultValue={isEdit?.medical_examiner_date || ''}
                                                rules={{ required: true }}
                                                render={({ field }) => (
                                                    <Form.Control
                                                        type="date"
                                                        placeholder="Enter Medical Examination Date"
                                                        {...field}
                                                        isInvalid={errors.medical_examiner_date}
                                                    />
                                                )}
                                            />
                                        </Form.Group>
                                    </div>
                                    <div className="col-lg-6">
                                        <Form.Group className="mb-3">
                                            <Form.Label>Expiration Date of Medical Certificate:</Form.Label>
                                            <Controller
                                                name='exp_medical_examiner_date'
                                                control={control}
                                                defaultValue={isEdit?.exp_medical_examiner_date || ''}
                                                rules={{ required: true }}
                                                render={({ field }) => (
                                                    <Form.Control
                                                        type="date"
                                                        placeholder="Enter Expiration Date of Medical Certificate"
                                                        {...field}
                                                        isInvalid={errors.exp_medical_examiner_date}
                                                    />
                                                )}
                                            />
                                        </Form.Group>
                                    </div>
                                    <div className="col-lg-6">
                                        <Form.Group className="mb-3">
                                            <Form.Label>Medical Examiner’s Name:</Form.Label>
                                            <Controller
                                                name='medical_examiner_name'
                                                control={control}
                                                defaultValue={isEdit?.medical_examiner_name || ''}
                                                rules={{ required: true }}
                                                render={({ field }) => (
                                                    <Form.Control
                                                        type="text"
                                                        placeholder="Enter Medical Examiner’s Name"
                                                        {...field}
                                                        isInvalid={errors.medical_examiner_name}
                                                    />
                                                )}
                                            />
                                        </Form.Group>
                                    </div>
                                    <div className="col-lg-6">
                                        <Form.Group className="mb-3">
                                            <Form.Label>Medical Examiner’s Contact Information:</Form.Label>
                                            <Controller
                                                name='medical_examiner_contact'
                                                control={control}
                                                defaultValue={isEdit?.medical_examiner_contact || ''}
                                                rules={{ required: true }}
                                                render={({ field }) => (
                                                    <Form.Control
                                                        type="text"
                                                        placeholder="Enter Medical Examiner’s Contact Information"
                                                        {...field}
                                                        isInvalid={errors.medical_examiner_contact}
                                                    />
                                                )}
                                            />
                                        </Form.Group>
                                    </div>
                                    <div className="col-lg-6">
                                        <Form.Group className="mb-3">
                                            <Form.Label htmlFor='expiration_notification'>Expiration Notification:</Form.Label>
                                            <Controller
                                                name='expiration_notification'
                                                control={control}
                                                defaultValue={Boolean(isEdit?.expiration_notification) ? 1 : 0}
                                                rules={{ required: true }}
                                                render={({ field }) => (
                                                    <Form.Check
                                                        type="checkbox"
                                                        label="Receive reminders"
                                                        id='expiration_notification'
                                                        // {...field}
                                                        defaultChecked={field.value}
                                                        onChange={(e) => field.onChange(e.target.checked ? 1 : 0)}
                                                        isInvalid={errors.expiration_notification}
                                                    />
                                                )}
                                            />
                                        </Form.Group>
                                    </div>
                                </div>

                                <LoadingButtonWithForm
                                    isLoading={editLoading}
                                    name="Submit"
                                    className="text-white mt-auto w-100 mt-5"
                                />

                            </Form>
                        </>
                    )}


                </Offcanvas.Body>
            </Offcanvas >

        </>
    );
};

export default EditDriverApplication;